import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {SortDirection} from "@angular/material/sort";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class JournalEntryService {

    constructor(private http: HttpClient) {
    }

    find(sort: string, order: SortDirection, page: number, size: number, search, startDate, endDate, includeDeleted = false) {
        const sortParameter = sort ? `&sort=${sort},${order}` : '';
        const searchParameter = search ? `&search=${search}` : '';
        const startDatePart = startDate ? `&startDate=${moment(startDate).format('YYYY-MM-DD')}` : '';
        const endDatePart = endDate ? `&endDate=${moment(endDate).format('YYYY-MM-DD')}` : '';
        return this.http.get(`${GlobalConstants.apiURL}/journal-entries/find?page=${page}&includeDeleted=${includeDeleted}&size=${size}${startDatePart}${endDatePart}${sortParameter}${searchParameter}`);
    }
}
